"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var region_filter_options_1 = require("./region_filter_options");
var bind_1 = require("../bind");
var RegionSelectFilter = /** @class */ (function (_super) {
    tslib_1.__extends(RegionSelectFilter, _super);
    function RegionSelectFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showFullFilter: false,
        };
        return _this;
    }
    RegionSelectFilter.prototype.handleClick = function () {
        this.setState({
            showFullFilter: true,
        });
    };
    RegionSelectFilter.prototype.renderFilterOptions = function () {
        if (!this.state.showFullFilter) {
            return (React.createElement(region_filter_options_1.PlaceholderSelect, { onClick: this.handleClick, name: this.props.filter.options[0].name, loading: false }));
        }
        return (React.createElement(region_filter_options_1.default, { placeholderFilter: this.props.filter }));
    };
    RegionSelectFilter.prototype.render = function () {
        return (React.createElement("div", { className: "facet" },
            React.createElement("div", { className: "facet__heading" }, this.props.filter.name),
            this.renderFilterOptions()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], RegionSelectFilter.prototype, "handleClick", null);
    return RegionSelectFilter;
}(React.Component));
exports.default = RegionSelectFilter;
//# sourceMappingURL=region_select_filter.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/region_select_filter.js
// module id = Z8pg
// module chunks = 0 1 2 3 9 10 14 20